
export const INSTANCE_STATE = [
    'new',
    'initialize',
    'awaiting_3ds',
    'awaiting_processing',
    'awaiting_confirmation',
    'awaiting_withdraw',
    'sum_blocked',
    'processed',
    'withdrawed',
    'withdraw_cancelled',
    'refused',
    'cancelled',
    'expired'
];

